<template>
    <v-layout column>
        <v-toolbar dense flat style="background: none" class="authors">
            <v-toolbar-title class="pl-1 body-1">{{label}}</v-toolbar-title>
            <v-dialog
                    v-model="dialog"
                    persistent
                    scrollable
                    width="650"
            >
                <v-btn flat icon color="primary" slot="activator"
                       @click="()=>{ editIdx=null; Object.assign(item,freshItem); user={name:''}; }">
                    <v-icon>add</v-icon>
                </v-btn>
                <v-card>
                    <v-card-text>
                        <v-form v-model="formValid" ref="formRef">
                            <v-container>
                                <v-layout row wrap>

                                    <v-flex xs10>
                                        <x-user-select
                                                label="作者姓名"
                                                v-model="user"
                                                :rules="rules.required"
                                        />
                                    </v-flex>

                                    <v-flex xs2>
                                        <v-select
                                                label="作者序号"
                                                :items="validRanks"
                                                v-model="item.rank"
                                                :rules="rules.required"
                                        />
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                label="作者单位"
                                                v-model="item.deptName"
                                                :rules="rules.required"
                                                :disabled="item.userId && item.userId.length > 0"
                                        />
                                    </v-flex>

                                    <v-flex xs4>
                                        <v-checkbox
                                                v-model="item.corresponding"
                                                label="通讯作者"
                                                hide-details
                                        />
                                    </v-flex>

                                    <v-flex xs4>
                                        <v-checkbox
                                                v-model="item.coFirst"
                                                label="共同第一作者"
                                                hide-details
                                        />
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @click.native="dialog = false">取消</v-btn>
                        <v-btn color="primary" @click.native="onOk">确定</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>

        <v-data-table
                class="dense"
                :headers="headers"
                :items="value"
                hide-actions
        >
            <template slot="items" slot-scope="props">
                <td>{{props.item.rank}}</td>
                <td>{{props.item.name}}</td>
                <td>{{props.item.deptName}}</td>
                <td>{{props.item.corresponding?'是':''}}</td>
                <td>{{props.item.coFirst?'是':''}}</td>
                <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="onEdit(props.index, props.item)">
                            <v-icon color="teal">edit</v-icon>
                        </v-btn>
                        <span>编辑</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="onDel(props.index)">
                            <v-icon color="pink">delete</v-icon>
                        </v-btn>
                        <span>删除</span>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>

        <v-text-field
                :rules="rules.authors"
                :value="users"
                disabled/>
    </v-layout>
</template>
<script>
    import XUserSelect from '@/components/global/UserSelectForm'

    export default {
        name: 'paperAuthor',
        props: ['value', 'label', 'hint'],
        components: {XUserSelect},

        data() {
            return {
                headers: [
                    {text: '排序', sortable: false, value: 'rank', width: 18},
                    {text: '姓名', sortable: false, value: 'name'},
                    {text: '单位', sortable: false, value: 'rank'},
                    {text: '通迅作者', sortable: false, value: 'coresponding'},
                    {text: '共同一作', sortable: false, value: 'coFirst'},
                    {text: '操作', sortable: false, value: 'dbid'}
                ],

                dialog: false,
                freshItem: {
                    userId: null,
                    name: null,
                    rank: null,
                    deptName: null,
                    corresponding: false,
                    coFirst: false
                },
                item: {},

                editIdx: null,

                user: {
                    userId: null,
                    name: null,
                    deptName: null,
                },

                formValid: false,

                rankItems: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],

                rules: {
                    required: [
                        v => !!v || '该项必填'
                    ],
                    authors: [
                        v => !!v || '该项必填',
                        v => (!!v && (this.value || []).some(u => u.userId && u.userId.length > 0)) || "至少一位作者为本单位人员。"
                    ]
                }
            }
        },
        watch: {
            user: function (u) {
                // window.console.log(`in Authors watch user.`);
                // window.console.log(u);
                Object.assign(this.item, u);
            }
        },

        computed: {
            validRanks() {
                if (this.value) {
                    const rr = this.value.map(v => v.rank);
                    return this.rankItems.filter(v => !rr.includes(v));
                }
                return this.rankItems;
            },
            users(){
                return (this.value || []).map(a => `${a.name}(${a.rank})`).join(',')
            }
        },

        methods: {
            onEdit(idx, it) {
                // window.console.log(it);

                this.editIdx = idx;
                this.item = window.xutil.clone(it);
                this.user.userId = this.item.userId;
                this.user.name = this.item.name;
                this.user.deptName = this.item.deptName;

                this.dialog = true;
            },
            onOk() {
                if (this.$refs.formRef.validate()) {
                    let authors = window.xutil.clone(this.value);

                    if (this.editIdx != null) {
                        // window.console.log(this.item);
                        authors[this.editIdx] = window.xutil.clone(this.item);
                    } else {
                        // window.console.log(this.item);
                        authors.push(window.xutil.clone(this.item));
                    }

                    authors.sort((a, b) => a.rank - b.rank);
                    this.$emit('input', authors);
                    this.dialog = false;
                }
            },

            onDel(idx) {
                this.$emit('input', this.value.filter((v, i) => i !== idx))
            }
        }

    }
</script>
<style>
    div.v-menu__content.hide-list {
        display: none;
    }

    .authors.v-toolbar > .v-toolbar__content {
        padding-left: 0;
    }
</style>

